<template>
  <Dropdown>
    <template v-slot:default="{ contentVisible }">
      <button :aria-expanded="contentVisible ? 'true' : 'false'" class="no-style font-semibold">
        {{ userName }}
      </button>
    </template>
    <template v-slot:content>
      <ul style="min-width: 9rem">
        <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white">
          <button class="no-style w-full" role="link" @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </button>
        </li>
      </ul>
    </template>
  </Dropdown>
</template>

<script>
import Dropdown from './Dropdown';

export default {
  components: {
    Dropdown,
  },
  data() {
    return {
      userName: localStorage.getItem('fname') + ' ' + localStorage.getItem('lname'),
    };
  },
  methods: {
    logout() {
      const login_type = localStorage.getItem('login_type');
      if (login_type == 'teacher') this.$store.dispatch('authTeacher/logout');
      else this.$store.dispatch('authStudent/logout');
    },
  },
};
</script>
